import { phoneSpecialCharacters } from './formRegex';

//save phone with only digits -- no special characters
export const formatPhone = (object: any) => object?.phone?.replace(phoneSpecialCharacters, '');
